import {domains} from '../../constants/Utils';
import {aseWebsocketCommands} from '../../constants/aseWebsocketCommands';

export const ADMIN_RECURRENT_PROBLEM_FETCH_PENDING = 'ADMIN_RECURRENT_PROBLEM_FETCH_PENDING';
export const ADMIN_RECURRENT_PROBLEM_SWITCH = 'ADMIN_RECURRENT_PROBLEM_SWITCH';
export const ADMIN_RECURRENT_PROBLEM_ADD = 'ADMIN_RECURRENT_PROBLEM_ADD';
export const ADMIN_RECURRENT_PROBLEM_REMOVE = 'ADMIN_RECURRENT_PROBLEM_REMOVE';
export const ADMIN_RECURRENT_PROBLEM_UPDATE = 'ADMIN_RECURRENT_PROBLEM_UPDATE';
export const ADMIN_RECURRENT_PROBLEM_EDIT = 'ADMIN_RECURRENT_PROBLEM_EDIT';
export const ADMIN_RECURRENT_PROBLEM_SELECT_GROUP = 'ADMIN_RECURRENT_PROBLEM_SELECT_GROUP';

export const fetchRecurrentProblems = (domain, group) => dispatch => {
    switch (domain) {
        case domains.ASE: {
            return dispatch({
                type: ADMIN_RECURRENT_PROBLEM_FETCH_PENDING,
                aseWebsocket: true,
                command: aseWebsocketCommands.ASE_RECURRENT_PROBLEMS_GET,
                payload: {group}
            });
        }
    }
};

export const addItem = (domain, recurrentProblem) => dispatch => {
    switch (domain) {
        case domains.ASE: {
            return dispatch({
                type: ADMIN_RECURRENT_PROBLEM_ADD,
                aseWebsocket: true,
                command: aseWebsocketCommands.ASE_RECURRENT_PROBLEMS_CREATE,
                payload: {recurrentProblem}
            });
        }
    }
};

export const changePosition = (domain, recurrentProblem, oldIndex) => dispatch => {
    switch (domain) {
        case domains.ASE: {
            return dispatch({
                type: ADMIN_RECURRENT_PROBLEM_SWITCH,
                aseWebsocket: true,
                command: aseWebsocketCommands.ASE_RECURRENT_PROBLEMS_MOVE,
                payload: {oldIndex, newIndex: recurrentProblem.position, recurrentProblem}
            });
        }
    }
};

export const removeItem = (domain, recurrentProblem) => dispatch => {
    switch (domain) {
        case domains.ASE: {
            return dispatch({
                type: ADMIN_RECURRENT_PROBLEM_REMOVE,
                aseWebsocket: true,
                command: aseWebsocketCommands.ASE_RECURRENT_PROBLEMS_DELETE,
                payload: {recurrentProblem}
            });
        }
    }
};

export const updateItem = (domain, recurrentProblem, oldItem, index) => dispatch => {
    switch (domain) {
        case domains.ASE: {
            return dispatch({
                type: ADMIN_RECURRENT_PROBLEM_UPDATE,
                aseWebsocket: true,
                command: aseWebsocketCommands.ASE_RECURRENT_PROBLEMS_UPDATE,
                payload: {recurrentProblem, index, oldItem}
            });
        }
    }
};

export const editItem = index => dispatch => {
    dispatch({type: ADMIN_RECURRENT_PROBLEM_EDIT, payload: {index}});
};

export const storeSelectedCountryGroup = countryGroup => dispatch =>
    dispatch({
        type: ADMIN_RECURRENT_PROBLEM_SELECT_GROUP,
        payload: countryGroup
    });
